<div class="filter-container">
    <div class="filter-title">
        <span>Filtros</span>
        <button class="ml2" *ngIf="showReset" mat-button (click)="onReset.emit('')">Limpiar</button>
    </div>
    <ng-content class="filter-body" select=".filter-body">
    </ng-content>
</div>
